import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: "api/masters/index.php"
});


//////////////////
// WEBPACK FOOTER
// ./app/models/mastersModel.js
// module id = 21
// module chunks = 0